/* 46c16e66c7a96f27606077582b532687ba5475f7
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetFavoriteMutationVariables = Types.Exact<{
  advertId: Types.Scalars['ID'];
  state: Types.Scalars['Boolean'];
}>;


export type SetFavoriteMutation = { __typename?: 'Mutation', setFavoriteAdvert?: { __typename?: 'AdvertUserstate', id?: string | null, state?: Types.AdvertUserstateState | null, advert?: { __typename?: 'Advert', id?: string | null, advertUserstate?: { __typename?: 'AdvertUserstate', id?: string | null } | null } | null } | null };


export const SetFavoriteDocument = gql`
    mutation setFavorite($advertId: ID!, $state: Boolean!) {
  setFavoriteAdvert(advertId: $advertId, state: $state) {
    id
    state
    advert {
      id
      advertUserstate(state: FAVOURITE) {
        id
      }
    }
  }
}
    `;
export type SetFavoriteMutationFn = Apollo.MutationFunction<SetFavoriteMutation, SetFavoriteMutationVariables>;

/**
 * __useSetFavoriteMutation__
 *
 * To run a mutation, you first call `useSetFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFavoriteMutation, { data, loading, error }] = useSetFavoriteMutation({
 *   variables: {
 *      advertId: // value for 'advertId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSetFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<SetFavoriteMutation, SetFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFavoriteMutation, SetFavoriteMutationVariables>(SetFavoriteDocument, options);
      }
export type SetFavoriteMutationHookResult = ReturnType<typeof useSetFavoriteMutation>;
export type SetFavoriteMutationResult = Apollo.MutationResult<SetFavoriteMutation>;
export type SetFavoriteMutationOptions = Apollo.BaseMutationOptions<SetFavoriteMutation, SetFavoriteMutationVariables>;